import React, { createContext, useContext, useEffect, useState } from "react";
import { t as translate, dict } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("jnic_lang") || "fr";
    } catch {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("jnic_lang", lang);
    } catch (err) {
      console.warn("[LanguageContext] localStorage unavailable", err);
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => translate(lang, path);
  const toggle = () => setLang((l) => (l === "en" ? "fr" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, dict }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
